// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOGIN_TITLE = "P\u0159ihl\u00e1\u0161en\u00ed";
export const SIGNUP_TITLE = "Registrace";
